import styled from "styled-components";

export const TooltipContent = styled.div`
  background: #353f47;
  color: #ffffff;
  padding: 16px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  border-radius: 3px;
`;
